webpackJsonp([2],{

/***/ "+ApU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_List__ = __webpack_require__("uxIT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Ico__ = __webpack_require__("Kdfx");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        items: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].arrayOf(__WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].shape({
            type: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
            url: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
            label: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string
        }))
    },
    components: {
        List: __WEBPACK_IMPORTED_MODULE_1__objects_List__["a" /* default */],
        Ico: __WEBPACK_IMPORTED_MODULE_2__objects_Ico__["a" /* default */]
    }
});

/***/ }),

/***/ "+IVI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"title__root---2wMJg","prefix":"title__prefix---1lfSg","root--sub":"title__root--sub---14C_G title__root---2wMJg","rootSub":"title__root--sub---14C_G title__root---2wMJg"};

/***/ }),

/***/ "+fgz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"pagelist-slide","appear-class":"pagelist-slide-appear","appear-active-class":"pagelist-slide-appear-active"},on:{"afterEnter":_vm.onAfterEnter,"beforeLeave":_vm.onBeforeLeave}},[_c('section',{directives:[{name:"swipe",rawName:"v-swipe.up",value:(_vm.swipeUpHandler),expression:"swipeUpHandler",modifiers:{"up":true}},{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.isActive] = _vm.active, _obj )],on:{"&wheel":function($event){_vm.wheelListener($event)}}},[_c('SmoothScrollbar',{ref:"smoothScroll",attrs:{"tagName":"div","options":{ alwaysShowTracks: true },"active":_vm.$mq.matches('tabletLandscape')},on:{"scroll":_vm.onScroll}},[_vm._t("default"),_c('footer',{class:_vm.$style.footer,attrs:{"role":"contentinfo"}},[_vm._v("\n            © "+_vm._s(_vm.fullYear)+" Oliver Sim\n          ")])],2)],1)])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+tvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc09316_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("g9Sd");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("7yR/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc09316_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+uKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.isActive] = _vm.active, _obj )],attrs:{"aria-expanded":_vm.active},on:{"click":function($event){$event.preventDefault();_vm.onClick()}}},[_c('span',{class:_vm.$style.label},[_vm._v("Menu")])])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ye+1");
module.exports = __webpack_require__("9ZXO");


/***/ }),

/***/ "0IlN":
/***/ (function(module, exports) {

module.exports = [{"label":"Languages","ico":"code","data":[{"id":"html5","label":"HTML5","level":100},{"id":"css3","label":"CSS3","level":100},{"id":"es2015","label":"JavaScript (ES2015+)","level":100},{"id":"java","label":"Java","level":90},{"id":"kotlin","label":"Kotlin","level":90}]},{"label":"Front-End JavaScript Libraries","ico":"extension","data":[{"id":"bootstrap","label":"Bootstrap v4.0","level":100},{"id":"angularJs","label":"AngularJS 1.x","level":80},{"id":"angular","label":"Angular 9+","level":90},{"id":"react-js","label":"React JS","level":90}]},{"label":"Back-End Framework","ico":"checklist","data":[{"id":"nestJS","label":"NestJS","level":90},{"id":"spring-framework","label":"Spring Framework","level":80},{"id":"hibernate","label":"Hibernate","level":80},{"id":"nodejs","label":"NodeJS","level":90}]},{"label":"Database","ico":"terminal","data":[{"id":"sql","label":"SQL","level":100},{"id":"postgresql","label":"PostgreSQL","level":100},{"id":"mongodb","label":"MongoDB","level":100}]},{"label":"DevOps","ico":"terminal","data":[{"id":"Bamboo","label":"Bamboo","level":100},{"id":"github-actions","label":"GitHub Actions","level":100},{"id":"docker","label":"Docker","level":100},{"id":"kubernetes","label":"Kubernetes","level":80},{"id":"sonarqube","label":"SonarQube","level":100}]},{"label":"Tools","ico":"pencil","data":[{"id":"ide","label":"Intellij IDEA Ultimate","level":100},{"id":"database","label":"Intellij Database Tool","level":100},{"id":"warp","label":"Warp","level":90},{"id":"vcs","label":"GitHub CLI","level":90}]}]

/***/ }),

/***/ "0cFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DATE_PARSE_REGEXP */
/* unused harmony export MONTHS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
//
//
//
//
//
//




var DATE_PARSE_REGEXP = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/;
var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        value: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string
    },

    computed: {
        datetime: function datetime() {
            return new Date(DATE_PARSE_REGEXP.test(this.value) ? this.value : null);
        },
        month: function month() {
            return MONTHS[this.datetime.getMonth()];
        },
        text: function text() {
            return DATE_PARSE_REGEXP.test(this.value) ? this.month + ' ' + this.datetime.getFullYear() : '-';
        }
    }

});

/***/ }),

/***/ "0zuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.root,attrs:{"id":_vm.id,"tabIndex":"-1"}},[_c('div',{ref:"body",class:_vm.$style.body},[_c('span',{ref:"top",class:_vm.$style.intersectTop,attrs:{"data-pos":"top"}}),_vm._t("default"),_c('span',{ref:"bottom",class:_vm.$style.intersectBottom,attrs:{"data-pos":"bottom"}})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1ApT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export noop */
/* unused harmony export raf */
/* unused harmony export caf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return has; });
/**
 * A function that returns `undefined`
 *
 * @return {undefined}
 */
var noop = function noop() {};

/**
 * Fallback for `requestAnimationFrame`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
 */
var lastTime = 0;
var raf = global.requestAnimationFrame || function requestAnimationFrame(callback) {
  var currTime = new Date().getTime();
  var timeToCall = Math.max(0, 16 - (currTime - lastTime));
  var id = setTimeout(function () {
    return callback(currTime + timeToCall);
  }, timeToCall);
  lastTime = currTime + timeToCall;
  return id;
};
var caf = global.cancelAnimationFrame || function cancelAnimationFrame(id) {
  return clearTimeout(id);
};

var createAction = function createAction(mutation) {
  return function (_ref, payload) {
    var commit = _ref.commit;
    return commit(mutation, payload);
  };
};

var toInteger = function toInteger(str) {
  return parseInt(str, 10);
};

var objProto = Object.prototype;
var hasOwn = objProto.hasOwnProperty;
var has = function has(obj, key) {
  return hasOwn.call(obj, key);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "486U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":_vm.id},on:{"enter":_vm.updateRoute}},_vm._l((_vm.ids),function(id){return _c('PageSection',{key:id,attrs:{"title":("skills." + id),"subtitle":_vm.skills[id].label}},[_c('DataSet',{attrs:{"items":_vm.skills[id].list},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('SkillList',{attrs:{"skills":props.data}})]}}])})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5S0y":
/***/ (function(module, exports) {

module.exports = [{"id":4,"company":"Maybank","from":"2025-03-17","to":"","duration":"Present","title":"Senior Full Stack Developer","description":"Developing AI-driven enterprise applications, modernizing systems, and optimizing data pipelines and cloud resources at Maybank","_link":"https://maybank.com/"},{"id":3,"company":"EDAG Mobility IT","from":"2022-07-18","to":"2024-10-31","duration":"2 years 4 months","title":"Senior Full Stack Developer","description":"Collaborating with a leading German automotive company, engaged in the development of comprehensive automotive projects from initial concept to implementation and validation, ensuring top-notch quality and performance","_link":"https://my.edag.com/en/"},{"id":2,"company":"Etiqa Insurance and Takaful","from":"2020-09-17","to":"2022-07-17","duration":"2 years","title":"Full Stack Developer","description":"Working as Full Stack Developer for Insurance Company","_link":"https://etiqa.com.my/"},{"id":1,"company":"iFAST Corporation Ltd","from":"2019-02-01","to":"2019-11-01","duration":"10 months","title":"Full Stack Developer","description":"Working as Full Stack Engineer for multiple <abbr title=\"Business-To-Business\">B2B</abbr> Projects and maintaining/enhancing existing web apps","_link":"http://www.ifastcorp.com/"},{"id":0,"company":"Synergize Global","from":"2017-11-01","to":"2018-07-01","duration":"9 months","title":"Business Analyst Internship","description":"Analyse and strategies plans to approach a more effective collaborative events","_link":"https://www.facebook.com/synergize.global/"}]

/***/ }),

/***/ "6C9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("OIA1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f5979e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Mwj0");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("VGS/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f5979e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6tM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("lco2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180f5592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("TyXE");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("H1j4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_180f5592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7qXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("gnf5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d762c7d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("RaTu");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("PrUr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d762c7d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7yR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"table-list__root---3RrkR"};

/***/ }),

/***/ "902V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__database_jobs_json__ = __webpack_require__("5S0y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__database_jobs_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__database_jobs_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__database_education_json__ = __webpack_require__("w+aE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__database_education_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__database_education_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__database_skills_tech_json__ = __webpack_require__("0IlN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__database_skills_tech_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__database_skills_tech_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__database_skills_team_json__ = __webpack_require__("iym1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__database_skills_team_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__database_skills_team_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__database_portfolio_works_json__ = __webpack_require__("TToK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__database_portfolio_works_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__database_portfolio_works_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__database_social_json__ = __webpack_require__("fP2B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__database_social_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__database_social_json__);







/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    state: {
        jobs: __WEBPACK_IMPORTED_MODULE_0__database_jobs_json___default.a,
        education: __WEBPACK_IMPORTED_MODULE_1__database_education_json___default.a,
        works: __WEBPACK_IMPORTED_MODULE_4__database_portfolio_works_json___default.a,
        socials: __WEBPACK_IMPORTED_MODULE_5__database_social_json___default.a,
        skills: {
            _byId: ['tech', 'team'],
            tech: { label: 'Technological stack', list: __WEBPACK_IMPORTED_MODULE_2__database_skills_tech_json___default.a },
            team: { label: 'Teamwork skills and tools', list: __WEBPACK_IMPORTED_MODULE_3__database_skills_team_json___default.a }
        }
    }

});

/***/ }),

/***/ "9ZXO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_promise__ = __webpack_require__("wg8Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_promise__ = __webpack_require__("SCKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intersection_observer__ = __webpack_require__("p3C9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_what_input__ = __webpack_require__("0tN6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_what_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_what_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Root__ = __webpack_require__("ukWZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("WZ8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_mq__ = __webpack_require__("xo2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_swipe__ = __webpack_require__("y1+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_resize__ = __webpack_require__("LdKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_breakpoints_scss__ = __webpack_require__("NJKw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_breakpoints_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_styles_breakpoints_scss__);

/**
 * Main Application File
 */

//import 'babel-polyfill';














__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__shared_mq__["a" /* default */], { breakpoints: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ none: 0 }, __WEBPACK_IMPORTED_MODULE_11_styles_breakpoints_scss___default.a), ssr: 'desktop' });

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].directive('swipe', __WEBPACK_IMPORTED_MODULE_9__directives_swipe__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].directive('resize', __WEBPACK_IMPORTED_MODULE_10__directives_resize__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */]({
    store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
    el: '#app-root',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_6__containers_Root__["a" /* default */]);
    }
});

/***/ }),

/***/ "9q+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Ico__ = __webpack_require__("Kdfx");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        type: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
        link: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
        ico: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
        label: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string
    },
    components: {
        Ico: __WEBPACK_IMPORTED_MODULE_1__objects_Ico__["a" /* default */]
    }
});

/***/ }),

/***/ "Ardm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uF9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_539df5c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("wis0");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("yBQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_539df5c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B+Ja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{class:_vm.$style.root},_vm._l((_vm.items),function(item){return _c('li',{key:item.type,class:{'u-only-print': (item.type == 'link'), 'u-only-screen': (item.type == 'pdf')}},[_c('Ico',{attrs:{"name":item.type}}),_c('a',{attrs:{"href":item.url,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(item.label))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D0N4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"loader__root---1GX7T","body":"loader__body---1jtbT","line":"loader__line---3Ski4","is-entering":"loader__is-entering---gHnnt","isEntering":"loader__is-entering---gHnnt","line--pre":"loader__line--pre---2kPL3 loader__line---3Ski4","linePre":"loader__line--pre---2kPL3 loader__line---3Ski4","dots":"loader__dots---2hpfn"};

/***/ }),

/***/ "DMYB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"burger__root---1ZSsw","label":"burger__label---1KsjM","is-active":"burger__is-active---rG_j3","isActive":"burger__is-active---rG_j3"};

/***/ }),

/***/ "ErUn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620edbcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Ra4s");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("kw0s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620edbcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FRrh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"social-list__root---2xHkP"};

/***/ }),

/***/ "G3eE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_MeterBar__ = __webpack_require__("jMJG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        skills: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].arrayOf(__WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].shape({
            id: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].any,
            label: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].any,
            level: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].number
        }))
    },

    components: {
        MeterBar: __WEBPACK_IMPORTED_MODULE_1__objects_MeterBar__["a" /* default */]
    }
});

/***/ }),

/***/ "GhFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_constants__ = __webpack_require__("Og9w");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: __WEBPACK_IMPORTED_MODULE_0__shared_constants__["e" /* NAV_PATH_HOME */],
    label: 'Home'
}, {
    path: __WEBPACK_IMPORTED_MODULE_0__shared_constants__["f" /* NAV_PATH_JOBS */],
    label: 'Jobs'
}, {
    path: __WEBPACK_IMPORTED_MODULE_0__shared_constants__["d" /* NAV_PATH_EDUCATION */],
    label: 'Education'
}, {
    path: __WEBPACK_IMPORTED_MODULE_0__shared_constants__["h" /* NAV_PATH_SKILLS */],
    label: 'Skills'
}, {
    path: __WEBPACK_IMPORTED_MODULE_0__shared_constants__["g" /* NAV_PATH_PORTFOLIO */],
    label: 'Portfolio'
}]);

/***/ }),

/***/ "H1j4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"table__root---D_Oeh","caption":"table__caption---gIFqb","bracket":"table__bracket---2rvyM","data":"table__data---38zgb","footer":"table__footer---m1DCS","root--brackets":"table__root--brackets---2vPPB","rootBrackets":"table__root--brackets---2vPPB"};

/***/ }),

/***/ "IKfH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        prefix: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string.def('me'),
        title: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string.isRequired,
        subtitle: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string
    }
});

/***/ }),

/***/ "Iatj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"page__root---1CkN9","body":"page__body---3rTua","intersect":"page__intersect---1_3l_","intersect--top":"page__intersect--top---3-MbE page__intersect---1_3l_","intersectTop":"page__intersect--top---3-MbE page__intersect---1_3l_","intersect--bottom":"page__intersect--bottom---1tco0 page__intersect---1_3l_","intersectBottom":"page__intersect--bottom---1tco0 page__intersect---1_3l_"};

/***/ }),

/***/ "JN9V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Page__ = __webpack_require__("iB+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Section__ = __webpack_require__("6C9G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_SocialList__ = __webpack_require__("XjMz");
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        Page: __WEBPACK_IMPORTED_MODULE_1__components_Page__["a" /* default */],
        PageSection: __WEBPACK_IMPORTED_MODULE_2__components_Section__["a" /* default */],
        SocialList: __WEBPACK_IMPORTED_MODULE_3__objects_SocialList__["a" /* default */]
    },

    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])('data', ['socials'])

});

/***/ }),

/***/ "KGIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("wMO3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba5941d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("MBSc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba5941d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KZ3p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animejs__ = __webpack_require__("A5qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SmoothScrollbar__ = __webpack_require__("t5Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_ui_actions__ = __webpack_require__("jh0c");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var easing = function easing(t) {
    return Math.pow(t - 1, 3) + 1;
}; //eslint-disable-line

/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        SmoothScrollbar: __WEBPACK_IMPORTED_MODULE_3__components_SmoothScrollbar__["a" /* default */]
    },

    data: function data() {
        return {
            canScroll: false
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('ui', ['activeGroup', 'forcedScroll', 'pagelistScroll', 'route']), {
        active: function active() {
            if (this.$mq.matches('tablet-landscape')) {
                return this.activeGroup === __WEBPACK_IMPORTED_MODULE_4__shared_constants__["c" /* GROUP_PAGELIST */];
            }
            return this.activeGroup && this.activeGroup !== __WEBPACK_IMPORTED_MODULE_4__shared_constants__["b" /* GROUP_LOADER */];
        }
    }),

    created: function created() {
        this.fullYear = new Date().getFullYear();
    },


    watch: {
        forcedScroll: function forcedScroll(scroll) {
            var _this = this;

            if (scroll === true && this.route) {
                var scrollbar = this.$refs.smoothScroll.scrollbar;

                if (scrollbar) {
                    scrollbar.update();
                }
                this.$nextTick(function () {
                    _this.scrollTo(_this.route, _this.completeScrollRequest);
                });
            }
        }
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('ui', {
        updatePagelistscrollAction: __WEBPACK_IMPORTED_MODULE_5__store_ui_actions__["a" /* TYPES */].PAGELISTSCROLL_UPDATED,
        navigateToAction: __WEBPACK_IMPORTED_MODULE_5__store_ui_actions__["a" /* TYPES */].NAVIGATED_TO,
        completeScrollRequest: __WEBPACK_IMPORTED_MODULE_5__store_ui_actions__["a" /* TYPES */].PAGELISTSCROLL_COMPLETED
    }), {
        onAfterEnter: function onAfterEnter() {
            this.canScroll = true;
        },
        onBeforeLeave: function onBeforeLeave() {
            this.canScroll = false;
        },
        scrollTo: function scrollTo(id, callback) {

            if (typeof id === 'string' && id.length > 0) {
                var el = document.getElementById(id);

                if (el === undefined) {
                    throw new TypeError('Unable to find element with id "' + id + '"');
                }

                var scrollbar = this.$refs.smoothScroll.scrollbar;


                if (scrollbar) {
                    var offset = scrollbar.offset;

                    var _el$getBoundingClient = el.getBoundingClientRect(),
                        top = _el$getBoundingClient.top;

                    var rootTop = this.$el.getBoundingClientRect().top;

                    scrollbar.scrollTo(offset.x, offset.y + (top - rootTop), 1000, { easing: easing, callback: callback });
                } else {
                    var tl = __WEBPACK_IMPORTED_MODULE_2_animejs___default.a.timeline({
                        targets: this.$el,
                        autoplay: false,
                        easing: 'easeOutQuad'
                    });

                    tl.add([{
                        opacity: [1, 0],
                        duration: 300,
                        complete: function complete() {
                            return el.scrollIntoView();
                        }
                    }, {
                        opacity: [0, 1],
                        duration: 300,
                        delay: 200
                    }]);

                    tl.complete = callback;

                    tl.play();
                }
            }
        },
        wheelListener: function wheelListener(e) {

            if (this.canScroll === false || this.activeNav || this.$mq.matchesUntil('tablet-landscape')) {
                return;
            }

            if (e.deltaY < 0 && this.activeGroup === __WEBPACK_IMPORTED_MODULE_4__shared_constants__["c" /* GROUP_PAGELIST */] && this.pagelistScroll <= 0) {
                this.navigateToAction({ route: __WEBPACK_IMPORTED_MODULE_4__shared_constants__["e" /* NAV_PATH_HOME */] });
            }
        },
        swipeUpHandler: function swipeUpHandler() {

            if (this.activeNav || this.$mq.matchesUntil('tablet-landscape')) {
                return;
            }

            if (this.activeGroup === __WEBPACK_IMPORTED_MODULE_4__shared_constants__["c" /* GROUP_PAGELIST */] && this.pagelistScroll <= 0) {
                this.navigateToAction({ route: __WEBPACK_IMPORTED_MODULE_4__shared_constants__["e" /* NAV_PATH_HOME */] });
            }
        },
        onScroll: function onScroll(_ref) {
            var offset = _ref.offset;
            var _offset$y = offset.y,
                y = _offset$y === undefined ? 0 : _offset$y;

            this.updatePagelistscrollAction(y);
        }
    })
});

/***/ }),

/***/ "Kdfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("tfBI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f58bebe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("fCh4");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("lEZb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f58bebe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LdKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isServer(vnode) {
    return typeof vnode.componentInstance !== 'undefined' && vnode.componentInstance.$isServer;
}

/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'v-resize',

    bind: function bind(el, _ref, vnode) {
        var value = _ref.value;


        if (el.__resize || isServer(vnode)) {
            return;
        }

        var print = false;

        var printMQ = window.matchMedia('print');

        printMQ.addListener(function (_ref2) {
            var matches = _ref2.matches;

            print = matches;
        });

        var resizeHandler = function resizeHandler() {
            if (print === false) {
                value.apply(undefined, arguments);
            }
        };

        el.__resize = resizeHandler; //eslint-disable-line no-param-reassign

        window.addEventListener('resize', resizeHandler, false);
        window.addEventListener('orientationchange', resizeHandler, false);
    },
    unbind: function unbind(el, binding, vnode) {
        if (isServer(vnode)) {
            return;
        }

        var resize = el.__resize;
        if (typeof resize === 'function') {
            window.removeEventListener('resize', resize, false);
            window.removeEventListener('orientationchange', resize, false);
            delete el.__resize; //eslint-disable-line no-param-reassign
        }
    }
});

/***/ }),

/***/ "M/xk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MBSc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":_vm.id},on:{"enter":_vm.updateRoute}},[_c('PageSection',{attrs:{"title":"education","subtitle":"Learning never ends"}},[_c('TableList',_vm._l((_vm.items),function(item){return _c('SummaryTable',{key:item.id,attrs:{"caption":"title","data":item,"styles":['brackets']}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mwj0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.root},[_c('SectionTitle',{class:_vm.$style.title,attrs:{"prefix":_vm.prefix,"title":_vm.title,"subtitle":_vm.subtitle}}),_c('div',{ref:"body",class:_vm.$style.body,style:({ transform: ("translate3d(0, " + _vm.scrollAmount + "px, 0)") })},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ND8W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("KZ3p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130be80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("+fgz");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("nBvT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130be80e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NJKw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mobile":"480","tablet":"768","tablet-landscape":"1024","tabletLandscape":"1024","desktop":"1280","wide":"1600","fullhd":"1920"};

/***/ }),

/***/ "OIA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_Title__ = __webpack_require__("T7hy");

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            rootOffsetTop: 0
        };
    },


    props: {
        title: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].string,
        subtitle: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].string,
        prefix: String
    },

    components: {
        SectionTitle: __WEBPACK_IMPORTED_MODULE_3__objects_Title__["a" /* default */]
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])('ui', ['pagelistScroll']), {
        scrollAmount: function scrollAmount() {
            var amount = this.rootOffsetTop + parseInt(window.innerHeight * 0.2, 10) - (this.pagelistScroll + window.innerHeight / 2);
            return Math.floor(amount * 0.1);
        }
    }),

    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.rootOffsetTop = _this.$el.offsetTop;
        }, 100);
    }
});

/***/ }),

/***/ "OTIU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"meter-bar__root---1JrKz","label":"meter-bar__label---3yilO","bar":"meter-bar__bar---2Kse-","bar-down":"meter-bar__bar-down---1cAYs","barDown":"meter-bar__bar-down---1cAYs","bar-up":"meter-bar__bar-up---2xypH","barUp":"meter-bar__bar-up---2xypH","bar--10":"meter-bar__bar--10---2Seyy","bar10":"meter-bar__bar--10---2Seyy","value":"meter-bar__value---37txy","bar--20":"meter-bar__bar--20---3rBeg","bar20":"meter-bar__bar--20---3rBeg","bar--30":"meter-bar__bar--30---27ub7","bar30":"meter-bar__bar--30---27ub7","bar--40":"meter-bar__bar--40---2pyUw","bar40":"meter-bar__bar--40---2pyUw","bar--50":"meter-bar__bar--50---2P3cV","bar50":"meter-bar__bar--50---2P3cV","bar--60":"meter-bar__bar--60---17_HV","bar60":"meter-bar__bar--60---17_HV","bar--70":"meter-bar__bar--70---2csR1","bar70":"meter-bar__bar--70---2csR1","bar--80":"meter-bar__bar--80---1hpVs","bar80":"meter-bar__bar--80---1hpVs","bar--90":"meter-bar__bar--90---Ren3t","bar90":"meter-bar__bar--90---Ren3t","bar--100":"meter-bar__bar--100---Wk48t","bar100":"meter-bar__bar--100---Wk48t"};

/***/ }),

/***/ "Og9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NAV_PATH_HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NAV_PATH_JOBS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NAV_PATH_EDUCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NAV_PATH_SKILLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NAV_PATH_PORTFOLIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GROUP_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GROUP_COVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GROUP_PAGELIST; });
// NAV PATHS

var NAV_PATH_HOME = 'home';
var NAV_PATH_JOBS = 'jobs';
var NAV_PATH_EDUCATION = 'education';
var NAV_PATH_SKILLS = 'skills';
var NAV_PATH_PORTFOLIO = 'portfolio';

var GROUP_LOADER = 'loader';
var GROUP_COVER = 'cover';
var GROUP_PAGELIST = 'pagelist';

/***/ }),

/***/ "PMP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("G3eE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcd23b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("t9zn");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("oSAA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcd23b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PrUr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"nav-timing-in":"250","navTimingIn":"250","nav-items-delay-in":"800","navItemsDelayIn":"800","nav-pattern-delay-in":"600","navPatternDelayIn":"600","nav-item-stagger":"90","navItemStagger":"90","nav-anim-out":"150","navAnimOut":"150","root":"nav__root---1kSrH","burger":"nav__burger---1BajY","is-visible":"nav__is-visible---zMUUp","isVisible":"nav__is-visible---zMUUp","menu":"nav__menu---12hlY","item":"nav__item---1Bynp","route":"nav__route---2EKDF","is-current":"nav__is-current---3POOT","isCurrent":"nav__is-current---3POOT","footer":"nav__footer---zC3jl","is-active":"nav__is-active---120tm","isActive":"nav__is-active---120tm","menu-enter-pattern":"nav__menu-enter-pattern---23a_u","menuEnterPattern":"nav__menu-enter-pattern---23a_u","menu-enter-bg":"nav__menu-enter-bg---2DLf3","menuEnterBg":"nav__menu-enter-bg---2DLf3"};

/***/ }),

/***/ "QZsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',{class:_vm.$style.root},[(_vm.prefix)?_c('b',{class:_vm.$style.prefix},[_vm._v("\n            "+_vm._s(_vm.prefix)+"\n        ")]):_vm._e(),_c('span',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.prefix ? ("." + _vm.title) : _vm.title))])]),(_vm.subtitle)?_c('p',{class:_vm.$style.rootSub},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R3MB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/marco-full.3881947d1d.jpg";

/***/ }),

/***/ "Ra4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('main',{class:_vm.$style.root,attrs:{"role":"main"}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RaTu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.isActive] = _vm.activeNav, _obj[_vm.$style.isVisible] = _vm.isLoaded, _obj )],attrs:{"role":"navigation"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.closeNav($event)}}},[_c('Burger',{class:_vm.$style.burger,attrs:{"onClick":_vm.toggleNavAction,"active":_vm.activeNav,"controls":"nav-menu"}}),_c('transition',{attrs:{"name":"navigation","duration":{ enter: _vm.totalTimingIn, leave: _vm.navAnimOut }}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeNav),expression:"activeNav"}],class:_vm.$style.menu,attrs:{"id":"nav-menu"}},_vm._l((_vm.paths),function(path,index){return _c('li',{key:path.path,class:[_vm.$style.item, ( _obj = {}, _obj[_vm.$style.isCurrent] = (_vm.route === path.path), _obj )],style:(_vm.navItemDelay(index))},[_c('a',{class:_vm.$style.route,attrs:{"href":("#" + (path.path)),"tabindex":_vm.tabIndex},on:{"click":function($event){$event.preventDefault();_vm.goTo(path.path)}}},[_vm._v(_vm._s(path.label))])])
var _obj;}))]),(_vm.navSocials)?_c('footer',{class:_vm.$style.footer},_vm._l((_vm.navSocials),function(ns){return _c('Anchor',{key:ns.type,attrs:{"link":ns.url,"ico":ns.type,"tabindex":_vm.tabIndex,"aria-label":((ns.type) + " profile: " + (ns.label))}})})):_vm._e()],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T7hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("IKfH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc5d17e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("QZsd");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("+IVI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc5d17e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TToK":
/***/ (function(module, exports) {

module.exports = [{"id":"bora","project":"BORA Website","date":"2022-07-07","stack":"WebFlow","tasks-description":"Developing and designing NGO website using WebFlow","_link":"https://www.bringingbackourrareanimals.org/"},{"id":"rs-prop","project":"RS Property Services","date":"2022-01-01","stack":"HTML, JavaScript, CSS","tasks-description":"Developing and designing interior design website for client.","_link":"https://rspropservices.com/"},{"id":"mqbc-my","project":"Malaysia-Qatar Business Council Website","date":"2021-09-01","stack":"HTML, JavaScript, CSS","tasks-description":"Developing and designing business council website and configuring email domains for client.","_link":"https://mqbc.com.my/"},{"id":"frankitas-website","project":"Frankitas Website 2.0","date":"2020-01-01","stack":"HTML, Liquid, Shopify","tasks-description":"Modifying premium theme's code and server configuration for domains. Optimizing site structure to improve SEO rankings.","_link":"https://www.frankitas.co/"},{"id":"aquachain-website","project":"Aquachain Website","date":"2018-06-01","stack":"HTML, CSS, Javascript, Frontend Design System","tasks-description":"Contributed to design for Aquachain landing page and logo.","_link":"https://aquachain.github.io/"}]

/***/ }),

/***/ "TyXE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:[_vm.$style.root, _vm.tableStyles]},[(_vm.caption)?_c('h3',{class:_vm.$style.caption,attrs:{"id":("table-" + _vm.id)}},[_vm._v(_vm._s(_vm.caption)+":\n        "),(_vm.data._link)?_c('a',{attrs:{"href":_vm.data._link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.captionLabel))]):_vm._e(),(!_vm.data._link)?_c('span',[_vm._v(_vm._s(_vm.captionLabel))]):_vm._e()]):_vm._e(),(_vm.hasBrackets)?_c('div',{class:_vm.$style.bracket}):_vm._e(),_c('table',{class:_vm.$style.data,attrs:{"aria-labelledby":("table-" + _vm.id)}},[_c('tbody',_vm._l((_vm.rows),function(value,heading){return _c('tr',{key:heading,attrs:{"data-row":heading}},[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(heading))]),(_vm.isDate(heading))?_c('td',[_c('FormattedTime',{attrs:{"value":value}})],1):_c('td',{domProps:{"innerHTML":_vm._s(value)}})])}))]),(_vm.data._meta)?_c('footer',{class:_vm.$style.footer},_vm._l((_vm.data._meta),function(meta){return _c('Anchor',{key:meta.link,attrs:{"type":"cursor","link":meta.link,"ico":meta.type,"label":meta.label || meta.type,"title":_vm.metaTitle(meta.type, _vm.data[_vm.caption])}})})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ud+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        label: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string.isRequired,
        value: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].number.isRequired
    },

    computed: {
        barValueClass: function barValueClass() {
            return this.$style['bar--' + this.value];
        }
    }
});

/***/ }),

/***/ "UzFY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"appear-enter-timing":"3250","appearEnterTiming":"3250","slide-enter-timing":"800","slideEnterTiming":"800","slide-leave-timing":"2250","slideLeaveTiming":"2250","root":"cover__root---1g1Nj","pic":"cover__pic---319qF","is-app-loaded":"cover__is-app-loaded---3CfW2","isAppLoaded":"cover__is-app-loaded---3CfW2","avatar":"cover__avatar---21fJr","body":"cover__body---1odFS","headline":"cover__headline---18ICL","text":"cover__text---1TP_5","footer":"cover__footer---3CjAE","social-list":"cover__social-list---njmeh","socialList":"cover__social-list---njmeh","scrollhint":"cover__scrollhint---2-4wM","scrollhint-ico":"cover__scrollhint-ico---1cgir","scrollhintIco":"cover__scrollhint-ico---1cgir","intersect":"cover__intersect---3ThOX","intersect--top":"cover__intersect--top---1ddei cover__intersect---3ThOX","intersectTop":"cover__intersect--top---1ddei cover__intersect---3ThOX","intersect--bottom":"cover__intersect--bottom---1EXNY cover__intersect---3ThOX","intersectBottom":"cover__intersect--bottom---1EXNY cover__intersect---3ThOX"};

/***/ }),

/***/ "VGS/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"section__root---18dwh","title":"section__title---2kzog","body":"section__body---1KvGW"};

/***/ }),

/***/ "VIcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.rootHigh] = _vm.value > 80, _obj )]},[_c('span',{class:_vm.$style.label},[_vm._v(_vm._s(_vm.label))]),_c('b',{class:[_vm.$style.bar, _vm.barValueClass]},[_c('span',{class:_vm.$style.value},[_vm._v(_vm._s(_vm.value)+"%")])])])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vetc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_marco_jpg__ = __webpack_require__("pzSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_marco_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_marco_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_oliver_jpg__ = __webpack_require__("wWeI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_oliver_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_oliver_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_marco_full_jpg__ = __webpack_require__("R3MB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_marco_full_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_marco_full_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objects_Ico__ = __webpack_require__("Kdfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_SocialList__ = __webpack_require__("XjMz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_observer_mixin__ = __webpack_require__("se/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_ui_actions__ = __webpack_require__("jh0c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_utils__ = __webpack_require__("1ApT");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import anime from 'animejs';










var Avatar = function Avatar() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "zX1c"));
};

/* harmony default export */ __webpack_exports__["a"] = ({

  components: {
    Avatar: Avatar,
    Ico: __WEBPACK_IMPORTED_MODULE_6__objects_Ico__["a" /* default */],
    SocialList: __WEBPACK_IMPORTED_MODULE_7__objects_SocialList__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__shared_observer_mixin__["a" /* default */]],

  data: function data() {
    return {
      id: __WEBPACK_IMPORTED_MODULE_2__shared_constants__["e" /* NAV_PATH_HOME */],
      NAV_PATH_JOBS: __WEBPACK_IMPORTED_MODULE_2__shared_constants__["f" /* NAV_PATH_JOBS */],
      oli: __WEBPACK_IMPORTED_MODULE_4_images_oliver_jpg___default.a,
      marco: __WEBPACK_IMPORTED_MODULE_3_images_marco_jpg___default.a,
      animal: __WEBPACK_IMPORTED_MODULE_5_images_marco_full_jpg___default.a,
      firstEnter: true,
      canScroll: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    socials: function socials(state) {
      return state.data.socials;
    },
    activeGroup: function activeGroup(state) {
      return state.ui.activeGroup;
    },
    activeNav: function activeNav(state) {
      return state.ui.activeNav;
    },
    isAppLoaded: function isAppLoaded(state) {
      return state.ui.isLoaded;
    }
  }), {
    transitionDuration: function transitionDuration() {
      var _$style = this.$style,
          appearEnterTiming = _$style.appearEnterTiming,
          slideEnterTiming = _$style.slideEnterTiming,
          slideLeaveTiming = _$style.slideLeaveTiming;


      if (this.transitionName === 'appear') {
        return {
          enter: Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils__["c" /* toInteger */])(appearEnterTiming),
          // BEWARE: dirty hach
          // avatar v-if cannot catch the updated transitionName
          // and removes the avatar asap
          leave: Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils__["c" /* toInteger */])(slideLeaveTiming)
        };
      }

      return {
        enter: Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils__["c" /* toInteger */])(slideEnterTiming),
        leave: Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils__["c" /* toInteger */])(slideLeaveTiming)
      };
    },
    active: function active() {
      if (this.$mq.matches('tablet-landscape')) {
        return this.activeGroup === __WEBPACK_IMPORTED_MODULE_2__shared_constants__["a" /* GROUP_COVER */];
      }
      return this.activeGroup === __WEBPACK_IMPORTED_MODULE_2__shared_constants__["a" /* GROUP_COVER */] || this.activeGroup === __WEBPACK_IMPORTED_MODULE_2__shared_constants__["c" /* GROUP_PAGELIST */];
    },
    transitionName: function transitionName() {
      return this.firstEnter ? 'appear' : 'slide';
    }
  }),

  watch: {
    activeGroup: function activeGroup(val, oldVal) {
      this.firstEnter = this.active && oldVal === __WEBPACK_IMPORTED_MODULE_2__shared_constants__["b" /* GROUP_LOADER */];
    }
  },

  created: function created() {
    var _this = this;

    this.$on('enter', function (_ref) {
      var id = _ref.id;

      _this.$store.dispatch('ui/' + __WEBPACK_IMPORTED_MODULE_9__store_ui_actions__["a" /* TYPES */].ROUTE_UPDATED, id);
    });
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('ui', {
    navigateToAction: __WEBPACK_IMPORTED_MODULE_9__store_ui_actions__["a" /* TYPES */].NAVIGATED_TO,
    scrollCompleted: __WEBPACK_IMPORTED_MODULE_9__store_ui_actions__["a" /* TYPES */].PAGELISTSCROLL_COMPLETED
  }), {
    gotoPagelist: function gotoPagelist() {
      var _this2 = this;

      this.navigateToAction({ route: __WEBPACK_IMPORTED_MODULE_2__shared_constants__["f" /* NAV_PATH_JOBS */], force: true });
      this.$nextTick(function () {
        _this2.scrollCompleted();
      });
    },
    swipeDownHandler: function swipeDownHandler() {
      if (this.activeNav || this.$mq.matchesUntil('tablet-landscape')) {
        return;
      }

      this.gotoPagelist();
    },
    wheelListener: function wheelListener(e) {

      if (this.canScroll === false || this.activeNav || this.$mq.matchesUntil('tablet-landscape')) {
        return;
      }

      if (e.deltaY > 0) {
        this.gotoPagelist();
      }
    },


    /*onEnter(el, done) {
         //const { pic, body, scrollhint } = this.$refs;
          if (this.firstEnter === true) {
             /*const timeline = anime.timeline({
                autoplay: false,
                easing: 'easeOutSine'
            });
             timeline.add({
                targets: [pic, body],
                opacity: [0, 1],
                translateX: (elm) => [(elm === pic ? '15%' : '7%'), 0],
                duration: 400,
                delay: 350,
                complete: done
            }).add({
                targets: scrollhint,
                opacity: 0.8,
                translateX: ['-50%', '-50%'],
                translateY: ['-10%', 0],
                duration: 500,
                delay: 3250 // 4000 - 350 - 400
            }).play();* /
             / *setTimeout(() => {
                done();
            }, this.timings.appearIn);* /
         } else {
             if (this.timeline) {
                this.timeline.pause();
                this.timeline.seek(0);
            }
             anime({
                targets: el,
                opacity: {
                    value: [0, 1],
                    duration: 0
                },
                translateY: ['-100%', 0],
                duration: 800,
                delay: 50,
                easing: 'easeInOutCirc',
                complete: done
            });
         }
    },*/

    onAfterEnter: function onAfterEnter() {
      this.canScroll = true;
    },
    onBeforeLeave: function onBeforeLeave() {
      this.canScroll = false;
    } //,

    /*onLeave(el, done) {
         const {
            pic, scrollhint, title, table, footer
        } = this.$refs;
         const timeline = anime.timeline({
            complete: done,
            autoplay: false,
            easing: 'easeInOutCubic'
        });
         this.timeline = timeline;
          if (this.firstEnter === false) {
             timeline.add([{
                targets: [pic, scrollhint],
                opacity: [1, 0],
                duration: 300
            }, {
                targets: title,
                translateY: '-300%',
                opacity: 0,
                duration: 500,
                offset: '+=350'
            }, {
                targets: table,
                translateY: '-200%',
                opacity: 0,
                duration: 500,
                offset: '-=300'
            }, {
                targets: footer,
                translateY: '-200%',
                opacity: 0,
                duration: 500,
                offset: '-=300'
            }, {
                targets: el,
                translateY: '-100%',
                duration: 700
            }, {
                targets: el,
                opacity: 0,
                duration: 200
            }]).play();
        }
    }*/

  })
});

/***/ }),

/***/ "W8yv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("9q+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4971e982_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("hzk9");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("dlQg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4971e982_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WZ8F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_module__ = __webpack_require__("902V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ui_module__ = __webpack_require__("k/Kz");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

    strict: "production" !== 'production',

    modules: {
        ui: __WEBPACK_IMPORTED_MODULE_3__ui_module__["a" /* default */],
        data: __WEBPACK_IMPORTED_MODULE_2__data_module__["a" /* default */]
    }

});

if (false) {
    if (module.hot) {
        // accept actions and mutations as hot modules
        module.hot.accept(['./data.module', './ui.module'], function () {
            var newData = require('./data.module').default; // eslint-disable-line no-shadow, global-require
            var newUi = require('./ui.module').default; // eslint-disable-line no-shadow, global-require
            store.hotUpdate({
                modules: {
                    ui: newUi,
                    data: newData
                }
            });
        });
    }
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "XE6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("YSEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0726a9bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("tErj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0726a9bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XjMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("+ApU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19324010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("B+Ja");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("FRrh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19324010_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YMoW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loader',{attrs:{"active":!_vm.isLoaded,"assetLoaded":true},on:{"loader-end":_vm.loadFinish}}),_c('Navigation',{attrs:{"paths":_vm.routes}}),_c('Wrapper',[_c('Cover'),_c('PageList',[_c('Jobs'),_c('Education'),_c('Skills'),_c('Portfolio'),_c('Contacts')],1),_c('BgPattern',{attrs:{"active":_vm.isLoaded}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YSEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__("iB+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Section__ = __webpack_require__("6C9G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_TableList__ = __webpack_require__("+tvZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Table__ = __webpack_require__("6tM+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__ = __webpack_require__("jh0c");
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        Page: __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */],
        PageSection: __WEBPACK_IMPORTED_MODULE_3__components_Section__["a" /* default */],
        TableList: __WEBPACK_IMPORTED_MODULE_4__objects_TableList__["a" /* default */],
        SummaryTable: __WEBPACK_IMPORTED_MODULE_5__objects_Table__["a" /* default */]
    },

    data: function data() {
        return {
            id: __WEBPACK_IMPORTED_MODULE_1__shared_constants__["g" /* NAV_PATH_PORTFOLIO */]
        };
    },


    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])('data', ['works', 'talks']),

    methods: {
        updateRoute: function updateRoute(_ref) {
            var id = _ref.id;

            this.$store.dispatch('ui/' + __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__["a" /* TYPES */].ROUTE_UPDATED, id);
        }
    }
});

/***/ }),

/***/ "ZXHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Vetc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3129328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("a/u3");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("UzFY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3129328_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a/u3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":_vm.transitionName,"duration":_vm.transitionDuration},on:{"afterEnter":_vm.onAfterEnter,"beforeLeave":_vm.onBeforeLeave}},[_c('section',{directives:[{name:"swipe",rawName:"v-swipe.down",value:(_vm.swipeDownHandler),expression:"swipeDownHandler",modifiers:{"down":true}},{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.isAppLoaded] = _vm.isAppLoaded, _obj )],attrs:{"id":_vm.id},on:{"&wheel":function($event){_vm.wheelListener($event)}}},[_c('span',{ref:"top",class:_vm.$style.intersectTop,attrs:{"data-pos":"top"}}),_c('div',{ref:"pic",class:_vm.$style.pic},[_c('transition',{attrs:{"name":"async-avatar","appear":"","duration":_vm.transitionDuration}},[(_vm.active)?_c('Avatar',{class:_vm.$style.avatar,attrs:{"active":_vm.active,"foreground":_vm.oli,"background":_vm.oli}}):_vm._e()],1)],1),_c('div',{class:_vm.$style.body},[_c('h2',{class:_vm.$style.headline,attrs:{"lang":"ja"}},[_vm._v("こんにちは！")]),_c('article',{class:_vm.$style.text},[_c('p',[_vm._v("My name is "),_c('b',[_vm._v("Oliver Sim.")])]),_c('p',[_vm._v("I am a "),_c('b',[_vm._v("Full Stack Developer")]),_vm._v(" / "),_c('b',[_vm._v("UX Engineer")]),_vm._v(" from Malaysia. Passionate about clean architecture\n          and best web development practice. Living in Selangor. I speak English, Malay, Mandarin, and some Hokkien.\n        ")]),_c('p',[_vm._v("Minimalist. Loves dogs. Enjoys football.")])]),_c('footer',{class:_vm.$style.footer},[_c('SocialList',{class:_vm.$style.socialList,attrs:{"items":_vm.socials}})],1)]),_c('a',{class:_vm.$style.scrollhint,attrs:{"href":("#" + _vm.NAV_PATH_JOBS)},on:{"click":function($event){$event.preventDefault();_vm.gotoPagelist($event)}}},[_c('div',[_vm._v("Get to know me")]),_c('Ico',{class:_vm.$style.scrollhintIco,attrs:{"name":"chevron-down"}})],1),_c('span',{ref:"bottom",class:_vm.$style.intersectBottom,attrs:{"data-pos":"bottom"}})])])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b7pA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"index__root---NHhpE_0"};

/***/ }),

/***/ "bg7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("JN9V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b23114_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("gWUU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b23114_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dlQg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"anchor__root---18Dmf","ico":"anchor__ico---3QWlR","label":"anchor__label---11dXt","root--cursor":"anchor__root--cursor---2fDjx","rootCursor":"anchor__root--cursor---2fDjx","blinking-cursor":"anchor__blinking-cursor---3PBsX","blinkingCursor":"anchor__blinking-cursor---3PBsX"};

/***/ }),

/***/ "eYCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
var _mutations;

/* eslint-disable no-param-reassign */

var TYPES = {
    NAV_TOGGLED: 'NAV_TOGGLED',
    ACTIVE_GROUP_UPDATED: 'ACTIVE_GROUP_UPDATED',
    ROUTE_UPDATED: 'ROUTE_UPDATED',
    PAGELISTSCROLL_UPDATED: 'PAGELISTSCROLL_UPDATED',
    PAGELISTSCROLL_REQUESTED: 'PAGELISTSCROLL_REQUESTED',
    PAGELISTSCROLL_COMPLETED: 'PAGELISTSCROLL_COMPLETED',
    APP_LOADED: 'APP_LOADED'
};

var mutations = (_mutations = {}, _mutations[TYPES.NAV_TOGGLED] = function (state, toggle) {
    state.activeNav = typeof toggle === 'undefined' ? !state.activeNav : !!toggle;
}, _mutations[TYPES.ACTIVE_GROUP_UPDATED] = function (state, activeGroup) {
    state.activeGroup = activeGroup;
}, _mutations[TYPES.APP_LOADED] = function (state, isLoaded) {
    state.isLoaded = isLoaded;
}, _mutations[TYPES.ROUTE_UPDATED] = function (state, route) {
    state.route = route;
}, _mutations[TYPES.PAGELISTSCROLL_UPDATED] = function (state, pagelistScroll) {
    state.pagelistScroll = pagelistScroll;
}, _mutations[TYPES.PAGELISTSCROLL_REQUESTED] = function (state, _ref) {
    var route = _ref.route;

    state.forcedScroll = !!route;
}, _mutations[TYPES.PAGELISTSCROLL_COMPLETED] = function (state) {
    state.forcedScroll = false;
}, _mutations);

/* eslint-enable no-param-reassign */

/***/ }),

/***/ "fCh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.$style.root, ("ico-" + _vm.name)]},[_c('use',_vm._b({},'use',{'xlink:href':("#ico-" + _vm.name)},false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fP2B":
/***/ (function(module, exports) {

module.exports = [{"type":"twitter","url":"https://twitter.com/olishiz","label":"@olishiz"},{"type":"pencil","url":"mailto:zhuen1101@hotmail.com","label":"zhuen1101@hotmail.com"},{"type":"github","url":"https://github.com/olishiz","label":"olishiz"},{"type":"linkedin","url":"https://www.linkedin.com/in/olishiz/","label":"in/olishiz"},{"type":"pdf","url":"https://drive.google.com/file/d/1IobIxRebHWA48C_7ekFvrZGwSpPFaVaA/view?usp=sharing","label":"pdf/resume"},{"type":"terminal","url":"https://olishiz.github.io/portfolio/","label":"Display VS Code Portfolio: olishiz.github.io/portfolio"}]

/***/ }),

/***/ "fcJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("qOJ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12f2f52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("uWt2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c12f2f52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g9Sd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gWUU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":"contacts","observe":false}},[_c('PageSection',{attrs:{"title":"Want to know more?","prefix":""}},[_c('SocialList',{attrs:{"items":_vm.socials}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gnf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__("1ApT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_Burger__ = __webpack_require__("tlxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Anchor__ = __webpack_require__("W8yv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__ = __webpack_require__("jh0c");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        Burger: __WEBPACK_IMPORTED_MODULE_4__objects_Burger__["a" /* default */],
        Anchor: __WEBPACK_IMPORTED_MODULE_5__objects_Anchor__["a" /* default */]
    },

    props: {
        paths: __WEBPACK_IMPORTED_MODULE_2_vue_types__["a" /* default */].arrayOf(__WEBPACK_IMPORTED_MODULE_2_vue_types__["a" /* default */].shape({
            path: __WEBPACK_IMPORTED_MODULE_2_vue_types__["a" /* default */].string.isRequired,
            label: __WEBPACK_IMPORTED_MODULE_2_vue_types__["a" /* default */].string.isRequired
        })).def([]),
        socials: __WEBPACK_IMPORTED_MODULE_2_vue_types__["a" /* default */].arrayOf(__WEBPACK_IMPORTED_MODULE_2_vue_types__["a" /* default */].string).def(['linkedin', 'twitter', 'github'])
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('ui', ['route', 'activeNav', 'isLoaded']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
        rawSocials: function rawSocials(state) {
            return state.data.socials;
        }
    }), {
        tabIndex: function tabIndex() {
            return this.activeNav ? 0 : -1;
        },
        navSocials: function navSocials() {
            var filters = this.socials;
            return this.rawSocials.filter(function (_ref) {
                var type = _ref.type;
                return filters.indexOf(type) !== -1;
            });
        },
        navItemsDelayIn: function navItemsDelayIn() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["c" /* toInteger */])(this.$style.navItemsDelayIn);
        },
        navPatternDelayIn: function navPatternDelayIn() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["c" /* toInteger */])(this.$style.navPatternDelayIn);
        },
        navTimingIn: function navTimingIn() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["c" /* toInteger */])(this.$style.navTimingIn);
        },
        navItemStagger: function navItemStagger() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["c" /* toInteger */])(this.$style.navItemStagger);
        },
        totalTimingIn: function totalTimingIn() {
            return Math.max(this.navTimingIn + this.navPatternDelayIn, this.navItemsDelayIn + this.paths.length * this.navItemStagger);
        },
        navAnimOut: function navAnimOut() {
            return Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["c" /* toInteger */])(this.$style.navAnimOut);
        }
    }),

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('ui', {
        toggleNavAction: __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__["a" /* TYPES */].NAV_TOGGLED,
        navigateToAction: __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__["a" /* TYPES */].NAVIGATED_TO
    }), {
        closeNav: function closeNav() {
            return this.toggleNavAction({ toggle: false, delay: this.navAnimOut + 300 });
        },
        navItemDelay: function navItemDelay(index) {
            if (!this.activeNav) {
                return null;
            }

            return { transitionDelay: this.navItemsDelayIn + index * this.navItemStagger + 'ms' };
        },
        goTo: function goTo(route) {
            var _this = this;

            this.closeNav().then(function () {
                return _this.navigateToAction({ route: route, force: true });
            });
        }
    })
});

/***/ }),

/***/ "hsJS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"list__root---1zDF2","item":"list__item---22AN7"};

/***/ }),

/***/ "hzk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style[("root--" + _vm.type)]] = _vm.type, _obj )],attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[(_vm.ico)?_c('Ico',{class:_vm.$style.ico,attrs:{"name":_vm.ico}}):_vm._e(),(_vm.label)?_c('span',{class:_vm.$style.label},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iB+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("sJjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031c93cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("0zuE");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("Iatj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031c93cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iym1":
/***/ (function(module, exports) {

module.exports = [{"label":"Workflow","ico":"split","data":[{"id":"scrum","label":"Scrum","level":90},{"id":"lean","label":"Lean Frontend","level":100},{"id":"code-review","label":"Code Review","level":100},{"id":"beer","label":"After Work Beers","level":100}]},{"label":"Tools","ico":"organization","data":[{"id":"vcs","label":"Git","level":100},{"id":"svn","label":"SVN","level":100},{"id":"github","label":"Github / Bitbucket","level":100},{"id":"jenkins","label":"Jenkins","level":80},{"id":"trello","label":"Trello","level":100},{"id":"docker","label":"Docker","level":80}]}]

/***/ }),

/***/ "jMJG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Ud+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56659bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("VIcD");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("OTIU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56659bd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jh0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_utils__ = __webpack_require__("1ApT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_mutations__ = __webpack_require__("eYCd");
var _actions;





var TYPES = {
    NAVIGATED_TO: 'NAVIGATED_TO_ACTION',
    NAV_TOGGLED: 'NAV_TOGGLED_ACTION',
    PAGELISTSCROLL_UPDATED: 'PAGELISTSCROLL_UPDATED_ACTION',
    APP_LOADED: 'APP_LOADED_ACTION',
    PAGELISTSCROLL_REQUESTED: 'PAGELISTSCROLL_REQUESTED_ACTION',
    PAGELISTSCROLL_COMPLETED: 'PAGELISTSCROLL_COMPLETED_ACTION',
    ROUTE_UPDATED: 'ROUTE_UPDATED_ACTION'
};

var actions = (_actions = {}, _actions[TYPES.NAV_TOGGLED] = function (_ref) {
    var commit = _ref.commit;

    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        toggle = _ref2.toggle,
        _ref2$delay = _ref2.delay,
        delay = _ref2$delay === undefined ? 0 : _ref2$delay;

    return new Promise(function (resolve) {
        commit(__WEBPACK_IMPORTED_MODULE_2__ui_mutations__["a" /* TYPES */].NAV_TOGGLED, toggle);
        setTimeout(function () {
            return resolve(toggle);
        }, delay);
    });
}, _actions[TYPES.PAGELISTSCROLL_UPDATED] = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_2__ui_mutations__["a" /* TYPES */].PAGELISTSCROLL_UPDATED), _actions[TYPES.APP_LOADED] = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_2__ui_mutations__["a" /* TYPES */].APP_LOADED), _actions[TYPES.ROUTE_UPDATED] = function (_ref3, route) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var activeGroup = route === __WEBPACK_IMPORTED_MODULE_0__shared_constants__["e" /* NAV_PATH_HOME */] ? __WEBPACK_IMPORTED_MODULE_0__shared_constants__["a" /* GROUP_COVER */] : __WEBPACK_IMPORTED_MODULE_0__shared_constants__["c" /* GROUP_PAGELIST */];

    if (state.forcedScroll === false) {
        commit(__WEBPACK_IMPORTED_MODULE_2__ui_mutations__["a" /* TYPES */].ACTIVE_GROUP_UPDATED, activeGroup);
        commit(__WEBPACK_IMPORTED_MODULE_2__ui_mutations__["a" /* TYPES */].ROUTE_UPDATED, route);
    }

    return activeGroup;
}, _actions[TYPES.NAVIGATED_TO] = function (_ref4, _ref5) {
    var dispatch = _ref4.dispatch;
    var route = _ref5.route,
        _ref5$force = _ref5.force,
        force = _ref5$force === undefined ? false : _ref5$force,
        _ref5$unblock = _ref5.unblock,
        unblock = _ref5$unblock === undefined ? false : _ref5$unblock;


    dispatch(TYPES.ROUTE_UPDATED, route);

    if (force === true) {
        dispatch(TYPES.PAGELISTSCROLL_REQUESTED, { route: route });
        if (unblock) {
            setTimeout(function () {
                dispatch(TYPES.PAGELISTSCROLL_COMPLETED);
            }, 0);
        }
    }
}, _actions[TYPES.PAGELISTSCROLL_REQUESTED] = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_2__ui_mutations__["a" /* TYPES */].PAGELISTSCROLL_REQUESTED), _actions[TYPES.PAGELISTSCROLL_COMPLETED] = Object(__WEBPACK_IMPORTED_MODULE_1__shared_utils__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_2__ui_mutations__["a" /* TYPES */].PAGELISTSCROLL_COMPLETED), _actions);

/***/ }),

/***/ "jsRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__("iB+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__objects_SkillList__ = __webpack_require__("PMP1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_DataSet__ = __webpack_require__("Ardm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Section__ = __webpack_require__("6C9G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__ = __webpack_require__("jh0c");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        Page: __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */],
        PageSection: __WEBPACK_IMPORTED_MODULE_5__components_Section__["a" /* default */],
        SkillList: __WEBPACK_IMPORTED_MODULE_3__objects_SkillList__["a" /* default */],
        DataSet: __WEBPACK_IMPORTED_MODULE_4__objects_DataSet__["a" /* default */]
    },

    data: function data() {
        return {
            id: __WEBPACK_IMPORTED_MODULE_1__shared_constants__["h" /* NAV_PATH_SKILLS */]
        };
    },


    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])({
        ids: function ids(state) {
            return state.data.skills._byId;
        },
        skills: function skills(state) {
            return state.data.skills;
        }
    }),

    methods: {
        updateRoute: function updateRoute(_ref) {
            var id = _ref.id;

            this.$store.dispatch('ui/' + __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__["a" /* TYPES */].ROUTE_UPDATED, id);
        }
    }
});

/***/ }),

/***/ "k/Kz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_mutations__ = __webpack_require__("eYCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ui_actions__ = __webpack_require__("jh0c");




/* harmony default export */ __webpack_exports__["a"] = ({

    namespaced: true,

    mutations: __WEBPACK_IMPORTED_MODULE_1__ui_mutations__["b" /* mutations */],

    actions: __WEBPACK_IMPORTED_MODULE_2__ui_actions__["b" /* actions */],

    state: {
        isLoaded: false,
        activeNav: false,
        activeGroup: __WEBPACK_IMPORTED_MODULE_0__shared_constants__["b" /* GROUP_LOADER */],
        route: '',
        pagelistScroll: 0,
        forcedScroll: false
    }

});

/***/ }),

/***/ "kw0s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"wrapper__root---1tcgq"};

/***/ }),

/***/ "lEZb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"ico__root---2_33e"};

/***/ }),

/***/ "lco2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Time__ = __webpack_require__("whSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objects_Anchor__ = __webpack_require__("W8yv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__("1ApT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var id = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        id += 1;
        return {
            id: id
        };
    },


    props: {
        styles: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].arrayOf(__WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string).def(['brackets']),
        caption: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
        data: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].object
    },

    components: {
        FormattedTime: __WEBPACK_IMPORTED_MODULE_1__objects_Time__["a" /* default */],
        Anchor: __WEBPACK_IMPORTED_MODULE_2__objects_Anchor__["a" /* default */]
    },

    computed: {
        tableStyles: function tableStyles() {
            var _this = this;

            return this.styles.map(function (s) {
                return _this.$style['root--' + s] || '';
            }).join(' ');
        },
        captionLabel: function captionLabel() {
            return this.caption && Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["b" /* has */])(this.data, this.caption) ? this.data[this.caption] : '';
        },
        hasBrackets: function hasBrackets() {
            return this.styles.indexOf('brackets') !== -1;
        },
        rows: function rows() {
            var _this2 = this;

            return Object.keys(this.data).reduce(function (o, key) {
                if (key !== _this2.caption && key !== 'id' && key.indexOf('_') !== 0) {
                    o[key] = _this2.data[key]; //eslint-disable-line no-param-reassign
                }
                return o;
            }, {});
        }
    },

    methods: {
        metaTitle: function metaTitle(type) {
            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';


            switch (type) {
                case 'video':
                    return 'Watch video for: ' + title;

                case 'slides':
                    return 'Slides for: ' + title;

                default:
                    return '';
            }
        },
        isDate: function isDate(heading) {
            return heading === 'to' || heading === 'from' || heading === 'date';
        }
    }
});

/***/ }),

/***/ "nBvT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"page-list__root---2l0sU","c-page":"page-list__c-page---1QDTu","cPage":"page-list__c-page---1QDTu","c-section":"page-list__c-section---O2n1H","cSection":"page-list__c-section---O2n1H","is-active":"page-list__is-active---2wYyn","isActive":"page-list__is-active---2wYyn","footer":"page-list__footer---mbNI9"};

/***/ }),

/***/ "nnMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"loader-animation"}},[_c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:_vm.$style.root},[_c('div',{class:['h1', _vm.$style.body, ( _obj = {}, _obj[_vm.$style.isEntering] = _vm.entering, _obj )]},[_c('span',{class:_vm.$style.line},[_vm._v("Developer.query(")]),_c('span',{class:_vm.$style.linePre},[_vm._v("'/usr/"),_c('mark',{staticClass:"u-type--mark"},[_vm._v("oliver+sim")]),_vm._v("',")]),_c('span',{class:_vm.$style.linePre},[_vm._v("'job="),_c('mark',{staticClass:"u-type--mark"},[_vm._v("senior fullstack dev")]),_vm._v("'")]),_c('span',{class:_vm.$style.line},[_vm._v(").then((me) =›"),_c('span',{class:_vm.$style.dots}),_vm._v(_vm._s(_vm.dots))])])])])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o1ay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        active: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].bool.def(false),
        onClick: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].func
    }

});

/***/ }),

/***/ "oSAA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"skill-list__root---VTs_f","item":"skill-list__item---3SEur"};

/***/ }),

/***/ "pcSJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        active: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].bool.def(false),
        assetLoaded: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].bool.def(false)
    },

    data: function data() {
        return {
            entering: false,
            dots: ''
        };
    },


    watch: {
        assetLoaded: function assetLoaded(v) {
            if (v === true) {
                this.maxRounds = Math.max(this.maxRounds, Math.ceil(this.rounds / 3));
            }
        }
    },

    created: function created() {
        this.rounds = 0;
        this.maxRounds = 2;
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            _this.entering = true;

            setTimeout(function () {
                _this.addDot();
                _this.$emit('loader-start');
                _this.interval = setInterval(_this.runLoader, 625);
            }, 1700);
        });
    },


    methods: {
        addDot: function addDot() {
            if (this.dots.length === 3) {
                this.dots = '';
                this.rounds += 1;
                return;
            }

            this.dots += '.';
        },
        runLoader: function runLoader() {
            if (this.rounds >= this.maxRounds) {

                if (this.assetLoaded === false) {
                    this.maxRounds += 1;
                    this.addDot();
                    return;
                }

                this.stopLoader();
                this.$emit('loader-end');
            } else {
                this.addDot();
            }
        },
        stopLoader: function stopLoader() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        }
    }

});

/***/ }),

/***/ "pzSf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/marco.e3fbd3bf10.jpg";

/***/ }),

/***/ "qKJu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qOJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__("iB+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Section__ = __webpack_require__("6C9G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_TableList__ = __webpack_require__("+tvZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Table__ = __webpack_require__("6tM+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__ = __webpack_require__("jh0c");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Page: __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */],
        PageSection: __WEBPACK_IMPORTED_MODULE_3__components_Section__["a" /* default */],
        TableList: __WEBPACK_IMPORTED_MODULE_4__objects_TableList__["a" /* default */],
        SummaryTable: __WEBPACK_IMPORTED_MODULE_5__objects_Table__["a" /* default */]
    },

    data: function data() {
        return {
            id: __WEBPACK_IMPORTED_MODULE_1__shared_constants__["f" /* NAV_PATH_JOBS */]
        };
    },


    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])({
        current: function current(state) {
            return state.data.jobs[0];
        },
        prev: function prev(state) {
            return state.data.jobs.slice(1);
        }
    }),

    methods: {
        updateRoute: function updateRoute(_ref) {
            var id = _ref.id;

            this.$store.dispatch('ui/' + __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__["a" /* TYPES */].ROUTE_UPDATED, id);
        }
    }
});

/***/ }),

/***/ "sJjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_observer_mixin__ = __webpack_require__("se/f");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__shared_observer_mixin__["a" /* default */]],
    props: {
        id: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string.isRequired
    }
});

/***/ }),

/***/ "sXHS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{class:_vm.$style.root,attrs:{"datetime":_vm.datetime.toISOString()}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "se/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        observe: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].bool.def(true)
    },

    created: function created() {
        this.observers = [];
    },
    mounted: function mounted() {

        if (this.observe) {
            this.observers.push(this.createTopObserver(this.$refs.top), this.createBottomObserver(this.$refs.bottom));
        }
    },
    destroyed: function destroyed() {
        if (this.observers.length > 0) {
            this.observers.forEach(function (observer) {
                return observer.disconnect();
            });
            this.observers.length = 0;
        }
    },


    methods: {
        createTopObserver: function createTopObserver(el) {
            var _this = this;

            var config = {
                threshold: [0]
            };

            var observer = new IntersectionObserver(function (_ref) {
                var entry = _ref[0];

                var targetInfo = entry.boundingClientRect;
                var rootBoundsInfo = entry.rootBounds;

                if (targetInfo.bottom < rootBoundsInfo.top) {
                    //console.log(this.id, 'top', 'leaving');
                } else if (targetInfo.top < rootBoundsInfo.bottom && targetInfo.top > rootBoundsInfo.height * 0.75) {
                    _this.$emit('enter', { id: _this.id, dir: 'top' });
                }
            }, config);

            observer.observe(el);

            return observer;
        },
        createBottomObserver: function createBottomObserver(el) {
            var _this2 = this;

            var config = {
                threshold: [1]
            };

            var observer = new IntersectionObserver(function (_ref2) {
                var entry = _ref2[0];

                var targetInfo = entry.boundingClientRect;
                var rootBoundsInfo = entry.rootBounds;
                var ratio = entry.intersectionRatio;
                if (targetInfo.bottom > rootBoundsInfo.top && ratio >= 1 && targetInfo.top < rootBoundsInfo.height / 4) {
                    _this2.$emit('enter', { id: _this2.id, dir: 'bottom' });
                }
                /* else if (targetInfo.top < rootBoundsInfo.top &&
                    targetInfo.bottom < rootBoundsInfo.bottom) {
                    console.log(this.id, 'bottom', 'leaving');
                }*/
            }, config);

            observer.observe(el);

            return observer;
        }
    }
});

/***/ }),

/***/ "t5Bm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_scrollbar__ = __webpack_require__("mjfB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_types__ = __webpack_require__("E0CL");



/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        options: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].object,
        tagName: String,
        active: __WEBPACK_IMPORTED_MODULE_1_vue_types__["a" /* default */].bool
    },

    render: function render(h) {
        if (this.tagName) return h(this.tagName, this.$slots.default);
        return this.$slots.default[0];
    },


    watch: {
        active: function active(_active) {
            this.$nextTick(_active ? this.attach : this.destroy);
        }
    },

    mounted: function mounted() {
        if (this.active) {
            this.$nextTick(this.attach);
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.destroy();
    },


    methods: {
        attach: function attach() {
            var _this = this;

            if (!this.scrollbar) {
                var el = this.$el || this.$slots.default[0].elm;
                this.scrollbar = __WEBPACK_IMPORTED_MODULE_0_smooth_scrollbar__["a" /* default */].init(el, this.options);
                this.scrollbar.addListener(function (status) {
                    return _this.$emit('scroll', status);
                });
            } else {
                this.scrollbar.update();
            }
        },
        destroy: function destroy() {
            if (this.scrollbar) {
                var el = this.$el || this.$slots.default[0].elm;
                el.removeAttribute('data-scrollbar');
                this.scrollbar.destroy();
                this.scrollbar = null;
            }
        }
    }
});

/***/ }),

/***/ "t9zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.root},_vm._l((_vm.skills),function(skill,index){return _c('li',{key:skill.id,class:_vm.$style.item,style:({transitionDelay: ((index * 150) + "ms")})},[(skill.level)?_c('MeterBar',{attrs:{"label":skill.label,"value":parseInt(skill.level, 10)}}):_c('p',[_vm._v("{skill.label}")])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tErj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":_vm.id},on:{"enter":_vm.updateRoute}},[_c('PageSection',{attrs:{"title":"portfolio.works","subtitle":"Latest agency & side projects"}},[_c('TableList',_vm._l((_vm.works),function(work){return _c('SummaryTable',{key:work.id,attrs:{"caption":"project","data":work,"styles":['brackets']}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tJB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("pcSJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dd49bd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("nnMZ");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("D0N4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dd49bd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tfBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        name: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string.isRequired
    }
});

/***/ }),

/***/ "tlxi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("o1ay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee1f97c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("+uKS");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("DMYB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee1f97c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uF9c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_types__ = __webpack_require__("E0CL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__objects_Ico__ = __webpack_require__("Kdfx");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        items: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].arrayOf(__WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].shape({
            label: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
            ico: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].string,
            data: __WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].arrayOf(__WEBPACK_IMPORTED_MODULE_0_vue_types__["a" /* default */].object)
        }))
    },

    components: {
        Ico: __WEBPACK_IMPORTED_MODULE_1__objects_Ico__["a" /* default */]
    }

});

/***/ }),

/***/ "uNQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Jobs__ = __webpack_require__("fcJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_Education__ = __webpack_require__("KGIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Skills__ = __webpack_require__("yb1n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_Portfolio__ = __webpack_require__("XE6E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_Contacts__ = __webpack_require__("bg7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Cover__ = __webpack_require__("ZXHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Navigation__ = __webpack_require__("7qXG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_PageList__ = __webpack_require__("ND8W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loader__ = __webpack_require__("tJB1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Wrapper__ = __webpack_require__("ErUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_routes__ = __webpack_require__("GhFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_ui_actions__ = __webpack_require__("jh0c");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import debounce from 'lodash/debounce';









//import Swipe from '@/components/Swipe';







var BgPattern = function BgPattern() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "JH6A"));
};

/* harmony default export */ __webpack_exports__["a"] = ({

    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_10__components_Loader__["a" /* default */],
        Cover: __WEBPACK_IMPORTED_MODULE_7__containers_Cover__["a" /* default */],
        Jobs: __WEBPACK_IMPORTED_MODULE_2__containers_Jobs__["a" /* default */],
        Skills: __WEBPACK_IMPORTED_MODULE_4__containers_Skills__["a" /* default */],
        Education: __WEBPACK_IMPORTED_MODULE_3__containers_Education__["a" /* default */],
        Portfolio: __WEBPACK_IMPORTED_MODULE_5__containers_Portfolio__["a" /* default */],
        Contacts: __WEBPACK_IMPORTED_MODULE_6__containers_Contacts__["a" /* default */],
        //Swipe,
        Navigation: __WEBPACK_IMPORTED_MODULE_8__containers_Navigation__["a" /* default */],
        Wrapper: __WEBPACK_IMPORTED_MODULE_11__components_Wrapper__["a" /* default */],
        PageList: __WEBPACK_IMPORTED_MODULE_9__containers_PageList__["a" /* default */],
        BgPattern: BgPattern
    },

    data: function data() {
        return {
            routes: __WEBPACK_IMPORTED_MODULE_12__shared_routes__["a" /* default */],
            location: this.$isServer ? { hash: '' } : global.location
        };
    },


    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])('ui', ['activeGroup', 'isLoaded', 'activeNav', 'pagelistScroll', 'route']), {
        validRoutes: function validRoutes() {
            return this.routes.map(function (_ref) {
                var path = _ref.path;
                return path;
            });
        }
    }),

    watch: {
        route: function route(_route) {
            //side effect!
            if (!this.$isServer) {
                if (this.getCurrentPath() !== _route) {
                    global.history.pushState(null, null, '#!' + _route);
                }
            }
        }
    },

    mounted: function mounted() {
        if (!this.$isServer) {
            global.addEventListener('popstate', this.onPopstate);
        }
    },
    beforeDestroy: function beforeDestroy() {
        global.removeEventListener('popstate', this.onPopstate);
    },


    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('ui', {
        navigateToAction: __WEBPACK_IMPORTED_MODULE_14__store_ui_actions__["a" /* TYPES */].NAVIGATED_TO,
        toggleAppLoadAction: __WEBPACK_IMPORTED_MODULE_14__store_ui_actions__["a" /* TYPES */].APP_LOADED
    }), {
        getCurrentPath: function getCurrentPath() {
            return this.location.hash.replace(/#!([a-z-_]+?)$/, '$1');
        },
        loadFinish: function loadFinish() {
            this.toggleAppLoadAction(true);
            var currentPath = this.getCurrentPath();
            var route = __WEBPACK_IMPORTED_MODULE_13__shared_constants__["e" /* NAV_PATH_HOME */];

            if (!this.$isServer && this.validRoutes.indexOf(currentPath) !== -1) {
                route = currentPath;
            }

            this.navigateToAction({ route: route, force: true });
        },
        onPopstate: function onPopstate() {
            var route = this.getCurrentPath();
            this.navigateToAction({ route: route, force: true });
        }
    })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "uWt2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":_vm.id},on:{"enter":_vm.updateRoute}},[_c('PageSection',{attrs:{"title":"jobs.current"}},[_c('TableList',[_c('SummaryTable',{attrs:{"caption":"company","data":_vm.current,"styles":['brackets']}})],1)],1),_c('PageSection',{attrs:{"title":"jobs.previous"}},[_c('TableList',_vm._l((_vm.prev),function(job){return _c('SummaryTable',{key:job.id,attrs:{"caption":"company","data":job,"styles":['brackets']}})}))],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ukWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uNQR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b17e643a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("YMoW");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("M/xk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b17e643a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uxIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vZ/l");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("hsJS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vZ/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'List',

    render: function render(h) {
        var _$style = this.$style,
            root = _$style.root,
            item = _$style.item;


        var children = this.$slots.default.map(function (child) {
            if (!child.tag) {
                return child;
            }

            if (child.tag === 'li') {
                var classes = child.data.class;
                child.data.class = Array.isArray(classes) ? [].concat(classes, [item]) : [classes, item]; //eslint-disable-line quote-props, no-param-reassign
                return child;
            }

            return h('li', { 'class': item }, [child]); //eslint-disable-line quote-props
        });

        return h('ul', { 'class': root }, children); //eslint-disable-line quote-props
    }
});

/***/ }),

/***/ "w+aE":
/***/ (function(module, exports) {

module.exports = [{"id":0,"institute":"Taylor's University","date-graduated":"December 2018","title":"Bachelor's Degree in Computer Science","grade":"<abbr title=\"Cumulative Grade Point Average\">CGPA</abbr> 3.88/4.00"}]

/***/ }),

/***/ "wMO3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_constants__ = __webpack_require__("Og9w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__("iB+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Section__ = __webpack_require__("6C9G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__objects_TableList__ = __webpack_require__("+tvZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Table__ = __webpack_require__("6tM+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__ = __webpack_require__("jh0c");
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Page: __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */],
        PageSection: __WEBPACK_IMPORTED_MODULE_3__components_Section__["a" /* default */],
        TableList: __WEBPACK_IMPORTED_MODULE_4__objects_TableList__["a" /* default */],
        SummaryTable: __WEBPACK_IMPORTED_MODULE_5__objects_Table__["a" /* default */]
    },

    data: function data() {
        return {
            id: __WEBPACK_IMPORTED_MODULE_1__shared_constants__["d" /* NAV_PATH_EDUCATION */]
        };
    },


    computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapState */])({
        items: function items(state) {
            return state.data.education;
        }
    }),

    methods: {
        updateRoute: function updateRoute(_ref) {
            var id = _ref.id;

            this.$store.dispatch('ui/' + __WEBPACK_IMPORTED_MODULE_6__store_ui_actions__["a" /* TYPES */].ROUTE_UPDATED, id);
        }
    }
});

/***/ }),

/***/ "wWeI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/oliver.a7cc760059.jpg";

/***/ }),

/***/ "whSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("0cFV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b5dfcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("sXHS");
function injectStyle (ssrContext) {
  this["$style"] = __webpack_require__("b7pA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60b5dfcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wis0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.root},_vm._l((_vm.items),function(item){return _c('li',{key:item.label,class:_vm.$style.item},[_c('span',{class:_vm.$style.label},[(item.ico)?_c('Ico',{class:_vm.$style.ico,attrs:{"name":item.ico}}):_vm._e(),_vm._v(_vm._s(item.label)+"\n        ")],1),_c('div',{class:_vm.$style.body},[_vm._t("default",null,{data:item.data})],2)])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xo2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var noop = function noop() {};

function serverMatchMedia(breakpoints, key, defaultKey) {

    var matches = key === defaultKey;

    return {
        media: '(min-width: ' + breakpoints[key] + 'px)',
        get matches() {
            return matches;
        },
        addListener: noop,
        removeListener: noop
    };
}

var toCamelCase = function toCamelCase(str) {
    return str.replace(/[-]{1,}(.)/g, function (_, l) {
        return l.toUpperCase();
    });
};

var clientMatchMedia = function clientMatchMedia(breakpoints, key) {
    return global.matchMedia('(min-width: ' + breakpoints[key] + 'px)');
};

var matcher = function matcher(ctx, fn) {
    return function (breakpoint) {
        var keys = ctx.keys; //eslint-disable-line no-shadow

        if (ctx.currentIdx === null) {
            return false;
        }
        return fn(keys.indexOf(toCamelCase(breakpoint)), ctx.currentIdx);
    };
};

/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var breakpoints = options.breakpoints,
            _options$ssr = options.ssr,
            ssr = _options$ssr === undefined ? '' : _options$ssr;


        if (!breakpoints) {
            throw new Error('You should provide some breakpoints');
        }

        var keys = Object.keys(options.breakpoints).filter(function (k) {
            return k.indexOf('-') === -1;
        }).sort(function (a, b) {
            return parseInt(breakpoints[a], 10) - parseInt(breakpoints[b], 10);
        });

        var $mq = new Vue({

            computed: {
                currentIdx: function currentIdx() {
                    var idx = this.keys.indexOf(this.current);
                    return idx !== -1 ? idx : null;
                }
            },

            data: {
                keys: keys,
                breakpoints: breakpoints,
                current: ''
            },

            created: function created() {
                var _this = this;

                var matchMedia = this.$isServer ? serverMatchMedia : clientMatchMedia;

                this.queries = this.keys.reduce(function (queries, key) {
                    var mql = matchMedia(breakpoints, key, ssr);

                    mql.addListener(_this.computeCurrent);

                    Object.defineProperty(_this, key, {
                        enumerable: true,
                        get: function get() {
                            return mql.matches;
                        }
                    });

                    queries[key] = mql; //eslint-disable-line no-param-reassign

                    return queries;
                }, {});

                if (this.$isServer) {
                    this.current = ssr;
                } else {
                    this.computeCurrent();
                }

                this.matches = matcher(this, function (a, b) {
                    return a <= b;
                });
                this.matchesExact = matcher(this, function (a, b) {
                    return a === b;
                });
                this.matchesUntil = matcher(this, function (a, b) {
                    return a > b;
                });
            },


            methods: {
                computeCurrent: function computeCurrent() {
                    var keys = this.keys; //eslint-disable-line no-shadow

                    for (var i = keys.length - 1; i >= 0; i -= 1) {

                        if (this[keys[i]] === true) {
                            this.current = keys[i];
                            return;
                        }
                    }
                    this.current = '';
                }
            }
        });

        Object.defineProperty(Vue.prototype, '$mq', {
            enumerable: false,
            writable: false,
            value: $mq
        });
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "y1+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var SwipeEvent = function () {
    function SwipeEvent(el) {
        var _this = this;

        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            onSwipe = _ref.onSwipe,
            _ref$modifiers = _ref.modifiers,
            modifiers = _ref$modifiers === undefined ? {} : _ref$modifiers;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SwipeEvent);

        this.touchstartY = 0;
        this.touchendY = 0;
        this.threshold = 20;

        this.onTouchStart = function (event) {
            _this.touchstartY = event.changedTouches[0].screenY;
        };

        this.onTouchEnd = function (event) {
            _this.touchendY = event.changedTouches[0].screenY;
            _this.handleGesture(event);
        };

        this.el = el;
        this.callback = onSwipe;
        this.modifiers = modifiers;
    }

    SwipeEvent.prototype.handleGesture = function handleGesture(event) {
        var touchendY = this.touchendY,
            touchstartY = this.touchstartY,
            threshold = this.threshold;


        if (Math.abs(touchendY - touchstartY) < threshold) {
            return;
        }

        var dir = touchendY < touchstartY ? 'down' : 'up';
        event.swipeDirection = dir; //eslint-disable-line no-param-reassign

        if (!this.modifiers.up && !this.modifiers.down) {
            this.callback(event);
            return;
        }

        if (this.modifiers.up && dir === 'up') {
            this.callback(event);
            return;
        }

        if (this.modifiers.down && dir === 'down') {
            this.callback(event);
        }
    };

    return SwipeEvent;
}();

/* harmony default export */ __webpack_exports__["a"] = ({

    name: 'v-swipe',

    bind: function bind(el, _ref2) {
        var value = _ref2.value,
            modifiers = _ref2.modifiers;


        if (el.__swipe) {
            return;
        }

        var swipe = new SwipeEvent(el, { onSwipe: value, modifiers: modifiers });

        el.__swipe = swipe; //eslint-disable-line no-param-reassign

        el.addEventListener('touchstart', swipe.onTouchStart, false);
        el.addEventListener('touchend', swipe.onTouchEnd, false);
    },
    unbind: function unbind(el) {
        var swipe = el.__swipe;
        if (swipe) {
            el.removeEventListener('touchstart', swipe.onTouchStart, false);
            el.removeEventListener('touchend', swipe.onTouchEnd, false);
            delete el.__swipe; //eslint-disable-line no-param-reassign
        }
    }
});

/***/ }),

/***/ "yBQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"data-set__root---11CRM","item":"data-set__item---1WzPc","label":"data-set__label---3wELH","ico":"data-set__ico---1F6Ou","body":"data-set__body---2MC9h"};

/***/ }),

/***/ "yb1n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("jsRW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352cd87a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("486U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352cd87a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ye+1":
/***/ (function(module, exports, __webpack_require__) {

//put base styles on top
__webpack_require__("qKJu");

if (false) {
    //eslint-disable-line no-undef

    if (module.hot) {

        module.hot.accept('./app.scss', function () {
            require('./app.scss'); //eslint-disable-line global-require
        });
    }
}

/***/ })

},[0]);


// WEBPACK FOOTER //
// js/app.152b71b551e09b130eb0.js